import { motion } from 'framer-motion';
import Button from '../UI/Button';

// Product-specific congratulations content
const congratulationsContent = {
  nad: {
    title: 'NAD+ Therapy',
    benefits: [
      'Your health profile is ideal for NAD+ supplementation',
      'You\'ll receive physician approval within 24 hours',
      'You can start treatment as soon as this week'
    ],
    highlight: 'cellular energy and healthy aging'
  },
  glutathione: {
    title: 'Glutathione Therapy',
    benefits: [
      'Your health profile is ideal for Glutathione supplementation',
      'You\'ll receive physician approval within 24 hours',
      'You can start treatment as soon as this week'
    ],
    highlight: 'antioxidant protection and radiant skin'
  },
  vitaminb12: {
    title: 'Vitamin B12 Therapy',
    benefits: [
      'Your health profile is ideal for B12 supplementation',
      'You\'ll receive physician approval within 24 hours',
      'You can start treatment as soon as this week'
    ],
    highlight: 'sustained energy and mental clarity'
  },
  lcarnitine: {
    title: 'L-Carnitine Therapy',
    benefits: [
      'Your health profile is ideal for L-Carnitine supplementation',
      'You\'ll receive physician approval within 24 hours',
      'You can start treatment as soon as this week'
    ],
    highlight: 'fat metabolism and athletic performance'
  }
};

export default function CongratulationsScreen({ product, onContinue }) {
  const content = congratulationsContent[product?.id] || congratulationsContent.nad;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-2xl mx-auto"
    >
      <div className="bg-white rounded-luxury shadow-luxury p-8">
        {/* Success Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
          className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-renuvia-gold to-renuvia-gold/60 rounded-full flex items-center justify-center"
        >
          <svg className="w-12 h-12 text-white" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg>
        </motion.div>

        <h1 className="text-3xl md:text-4xl font-bold text-charcoal text-center mb-3">
          Congratulations!
        </h1>

        <h2 className="text-xl md:text-2xl text-center mb-8">
          You've Been <span className="text-renuvia-gold font-bold">Pre-Approved</span> for {content.title}
        </h2>

        <p className="text-lg text-slate text-center mb-8">
          Based on your medical intake, you're cleared to begin treatment for {content.highlight}.
        </p>

        {/* Benefits */}
        <div className="bg-warm-beige rounded-xl p-6 mb-8">
          <h3 className="font-semibold text-charcoal text-center mb-4">
            What this means for you:
          </h3>
          <div className="space-y-4">
            {content.benefits.map((benefit, index) => (
              <motion.div
                key={benefit}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.4 + index * 0.1 }}
                className="flex items-start gap-3"
              >
                <div className="flex-shrink-0 w-6 h-6 mt-0.5">
                  <svg className="w-6 h-6 text-renuvia-gold" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-charcoal flex-1">{benefit}</span>
              </motion.div>
            ))}
          </div>
        </div>

        <Button onClick={onContinue} fullWidth>
          See Your Personalized Results →
        </Button>
      </div>
    </motion.div>
  );
}
